import React, {Suspense} from 'react';
import Spinner from '../components/loaders/Spinner';


const LazyLoader = ({Component}) => {
  return (
    <Suspense fallback={<Spinner />}>
      <Component/>
    </Suspense>
  );
}

export default LazyLoader;
